/**
 * Monkey-patch Node.prototype.removeChild and insertBefore to handle
 * Google Translate DOM mutations gracefully.
 *
 * Google Translate wraps text nodes in <font> tags, which moves them
 * out of their original parent. When React tries to remove or insert
 * relative to these nodes, it throws because they're no longer children
 * of the expected parent. This patch catches those cases silently.
 *
 * See: https://github.com/facebook/react/issues/11538
 */

export {};

if (typeof Node !== 'undefined') {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return originalRemoveChild.call(child.parentNode, child) as T;
      }
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.call(this, newNode, null) as T;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
